var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1191_12651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1295 -0.0913086H11.1296L11.1295 8.01035L17.8818 11.0662L11.1295 -0.0913086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9462 -0.0913086L4.19373 11.0662L10.9462 8.0097V-0.0913086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0837 16.4967L11.0005 16.5977V21.7579L11.0837 21.9998L17.8401 12.5239L11.0837 16.4967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0837 21.9998V16.4967L4.33124 12.5239L11.0837 21.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1295 15.2237L17.8818 11.2489L11.1295 8.19238V15.2237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19373 11.2489L10.9462 15.2237V8.19238L4.19373 11.2489Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1191_12651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.0687256)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthchain);
export default __webpack_public_path__ + "static/media/ethchain.4a4017eebdebee42b1c25486397c452e.svg";
export { ForwardRef as ReactComponent };